import { createStore, withProps } from '@ngneat/elf';
import { ColorSelectOption, SelectOption } from '../../components/form-builder/form-builder.types';
import { RefParams, RefParamsDto } from '@/types';
import { refTypeFactory } from '../ref-type-state/ref-type-state.store';

export interface RefParamsStateProps {
  response?: Partial<RefParams>;
  dto?: Partial<RefParamsDto>;
  refTypeIdSelected?: SelectOption;
  codeColorColorSelected?: ColorSelectOption;
}

export const refParamsFactory = (): RefParams => ({
  id: 0,
  code: '',
  description: '',
  refType: structuredClone(refTypeFactory()),
  codeColor: '',
});

export const refParamsInitialState: RefParamsStateProps = {
  response: structuredClone(refParamsFactory()),
  dto: { code: '', description: '', refTypeId: undefined },
  refTypeIdSelected: { name: '', code: undefined },
  codeColorColorSelected: { originalEvent: { isTrusted: false }, value: '' },
};

export const refParamStateStore = createStore({ name: 'refParam-state' }, withProps<RefParamsStateProps>({ ...refParamsInitialState }));
